module.exports = __webpack_public_path__ + "static/media/icon-stop.e8187fdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-stop.svg
// module id = 1257
// module chunks = 19